import type { CurrentUserInfo } from '@shared/models';

export type AdminUserRowIdentity = {
  id: string;
  email: string;
};

export type SignedInUserSnapshot = {
  userId: string;
  email: string;
};

/** JWT `sub` + email from session; undefined when not logged in or missing id. */
export function signedInSnapshot(
  info: CurrentUserInfo | undefined | null
): SignedInUserSnapshot | undefined {
  const userId = info?.userId?.trim();
  if (!userId) return undefined;
  return {
    userId,
    email: (info?.email ?? '').trim(),
  };
}

/** True when the grid row is the signed-in user (id matches `sub`, or email matches if both set). */
export function isSignedInUsersRow(
  row: AdminUserRowIdentity,
  signedIn: SignedInUserSnapshot | undefined | null
): boolean {
  if (!signedIn) return false;
  const isSameId =
    row.id.trim().toLowerCase() === signedIn.userId.trim().toLowerCase();
  if (isSameId) return true;
  const rowEmail = row.email.trim().toLowerCase();
  const tokenEmail = signedIn.email.trim().toLowerCase();
  return !!(rowEmail && tokenEmail && rowEmail === tokenEmail);
}
